import { memo } from "react";
import { ActionButtonIntent, TriggerButton } from "widgets";

import { pluralizeWord } from "@/app-utils/string.js";
import { notify } from "@/modules/notifications/notify.tsx";
import { showConfirmationDialog } from "@/services/ConfirmationService.ts";
import { useStopWorkflowsMutation } from "@/ui-modules/admin/graphql/job-admin-queries.gql.js";

interface KillWorkflowButton {
  selectedIds: number[];
  isDisabled: boolean;
  tooltip?: string;
  onSucceed?: VoidFunction;
}

/**
 * The Kill-Workflow button allows to kill workflow
 */
function KillWorkflowButton(props: KillWorkflowButton) {
  const [killJobs] = useStopWorkflowsMutation();

  const { selectedIds, isDisabled, tooltip, onSucceed } = props;

  return (
    <TriggerButton
      tooltip={tooltip}
      onPress={() =>
        showConfirmationDialog({
          title: "Terminate Jobs",
          message: "Are you sure you want to terminate this job ?",
          mainButton: {
            label: "Terminate job",
            onPress: () => {
              killJobs({ variables: { workflowEventIds: selectedIds } })
                .then(() => {
                  notify.success({ title: `${pluralizeWord("Job", selectedIds.length)} successfully terminated` });
                })
                .then(() => {
                  onSucceed?.();
                })
                .catch(() => {
                  notify.error({ title: `The ${pluralizeWord("Job", selectedIds.length)} can't be terminated` });
                });
            },
            intent: ActionButtonIntent.Danger,
          },
        })
      }
      isDisabled={isDisabled}
      icon="stop_circle"
      label="Terminate"
      showLabel
    />
  );
}

export default memo(KillWorkflowButton);
